// =====================================================================
// TransferDialog (Financeiro Tesouraria / S63) — transferência entre contas
// (1 débito na origem + 1 crédito no destino, atômico no backend).
// =====================================================================
import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, MenuItem, CircularProgress
} from "@material-ui/core";
import { toast } from "react-toastify";
import { transferAccounts, financeErrorMessage } from "../../services/financeService";
import useIsMobile from "../../utils/useIsMobile";

const TransferDialog = ({ open, accounts, onClose, onSaved }) => {
  const isMobile = useIsMobile();
  const active = (accounts || []).filter((a) => a.active);
  const [fromAccountId, setFromAccountId] = useState("");
  const [toAccountId, setToAccountId] = useState("");
  const [amount, setAmount] = useState("");
  const [entryDate, setEntryDate] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setFromAccountId(active[0] ? String(active[0].id) : "");
      setToAccountId(active[1] ? String(active[1].id) : "");
      setAmount(""); setEntryDate(""); setDescription("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSave = async () => {
    if (!fromAccountId || !toAccountId) { toast.error("Selecione origem e destino."); return; }
    if (fromAccountId === toAccountId) { toast.error("Origem e destino devem ser diferentes."); return; }
    const value = Number(String(amount).replace(",", "."));
    if (!value || value <= 0) { toast.error("Informe um valor válido."); return; }
    setSaving(true);
    try {
      await transferAccounts({
        fromAccountId: Number(fromAccountId),
        toAccountId: Number(toAccountId),
        amount: value,
        entryDate: entryDate || undefined,
        description: description || undefined
      });
      toast.success("Transferência registrada.");
      onSaved && onSaved();
    } catch (err) {
      toast.error(financeErrorMessage(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} maxWidth="xs" fullWidth fullScreen={isMobile}>
      <DialogTitle>Transferência entre contas</DialogTitle>
      <DialogContent>
        <TextField select label="De (origem)" value={fromAccountId} onChange={(e) => setFromAccountId(e.target.value)} fullWidth margin="dense">
          {active.map((a) => <MenuItem key={a.id} value={String(a.id)}>{a.name}</MenuItem>)}
        </TextField>
        <TextField select label="Para (destino)" value={toAccountId} onChange={(e) => setToAccountId(e.target.value)} fullWidth margin="dense">
          {active.map((a) => <MenuItem key={a.id} value={String(a.id)}>{a.name}</MenuItem>)}
        </TextField>
        <TextField label="Valor (R$)" type="number" value={amount} onChange={(e) => setAmount(e.target.value)} fullWidth margin="dense" inputProps={{ step: "0.01", min: "0" }} />
        <TextField label="Data" type="date" value={entryDate} onChange={(e) => setEntryDate(e.target.value)} fullWidth margin="dense" InputLabelProps={{ shrink: true }} helperText="Em branco = hoje." />
        <TextField label="Descrição (opcional)" value={description} onChange={(e) => setDescription(e.target.value)} fullWidth margin="dense" />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancelar</Button>
        <Button variant="contained" color="primary" onClick={handleSave} disabled={saving}
          startIcon={saving ? <CircularProgress size={16} /> : null}>Transferir</Button>
      </DialogActions>
    </Dialog>
  );
};

export default TransferDialog;
